export default __webpack_public_path__ + "static/media/Amardeep.b03f14c8.webp";